import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ed82ecfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "console-head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 01.5 // Command console", -1))
const _hoisted_3 = { class: "nerv-bezel" }
const _hoisted_4 = {
  ref: "screen",
  class: "nerv-screen console-screen"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "console-scan",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "console-grid" }
const _hoisted_7 = { class: "console-cell" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-data-label" }, "Area scan", -1))
const _hoisted_9 = {
  ref: "radarBox",
  class: "radar-box",
  "aria-hidden": "true"
}
const _hoisted_10 = {
  ref: "radarStatic",
  class: "layer"
}
const _hoisted_11 = {
  ref: "radarDyn",
  class: "layer"
}
const _hoisted_12 = {
  ref: "bearingEl",
  class: "radar-bearing nerv-caption"
}
const _hoisted_13 = { class: "nerv-caption cell-note" }
const _hoisted_14 = { class: "console-cell scope-cell" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-data-label" }, "Refresh trace", -1))
const _hoisted_16 = {
  ref: "scopeBox",
  class: "scope-box",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  ref: "scopeCanvas",
  class: "layer"
}
const _hoisted_18 = { class: "nerv-caption cell-note" }
const _hoisted_19 = {
  class: "boot-log",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 0,
  class: "boot-line"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "animate-cursor-blink" }, "_", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "console-cell" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-data-label" }, "Station readout", -1))
const _hoisted_25 = { class: "console-rows" }
const _hoisted_26 = { class: "nerv-datarow-key" }
const _hoisted_27 = { class: "nerv-datarow-value" }
const _hoisted_28 = { class: "console-big" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nerv-microcopy console-note" }, " Every number on this console is measured in your browser, on this device, and rendered here. Nothing is sent, stored or logged. The radar is decorative; the readings are not. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NervReadout = _resolveComponent("NervReadout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", {
        class: _normalizeClass(["nerv-status", _ctx.running ? 'nerv-lcd' : 'nerv-orange'])
      }, _toDisplayString(_ctx.running ? 'All systems nominal' : 'Boot sequence running'), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("canvas", _hoisted_10, null, 512),
              _createElementVNode("canvas", _hoisted_11, null, 512),
              _createElementVNode("span", _hoisted_12, "BRG 000", 512)
            ], 512),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.reduced ? 'Sweep parked, motion reduced per system setting' : 'Passive sweep, decorative'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("canvas", _hoisted_17, null, 512)
            ], 512),
            _createElementVNode("span", _hoisted_18, " min " + _toDisplayString(_ctx.histMin) + " / avg " + _toDisplayString(_ctx.histAvg) + " / max " + _toDisplayString(_ctx.histMax) + " fps, measured live ", 1),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLines, (line, i) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: i,
                  class: "boot-line"
                }, _toDisplayString(line), 1))
              }), 128)),
              (!_ctx.running)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _hoisted_22))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("dl", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.key,
                  class: "nerv-datarow"
                }, [
                  _createElementVNode("dt", _hoisted_26, _toDisplayString(row.key), 1),
                  _createElementVNode("dd", _hoisted_27, _toDisplayString(row.value), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_NervReadout, {
            label: "Refresh",
            value: _ctx.t.fps,
            unit: " fps",
            tone: "green",
            note: "Frames rendered by your browser"
          }, null, 8, ["value"]),
          _createVNode(_component_NervReadout, {
            label: "Session",
            value: _ctx.t.uptime,
            note: "Time on station"
          }, null, 8, ["value"]),
          (_ctx.t.heapUsedMb !== null)
            ? (_openBlock(), _createBlock(_component_NervReadout, {
                key: 0,
                label: "JS heap",
                value: _ctx.t.heapUsedMb.toFixed(1),
                unit: " MB",
                tone: "cyan",
                note: "Live from this tab"
              }, null, 8, ["value"]))
            : (_ctx.t.rtt !== null)
              ? (_openBlock(), _createBlock(_component_NervReadout, {
                  key: 1,
                  label: "Round trip",
                  value: _ctx.t.rtt,
                  unit: " ms",
                  tone: "cyan",
                  note: "Reported by your browser"
                }, null, 8, ["value"]))
              : (_openBlock(), _createBlock(_component_NervReadout, {
                  key: 2,
                  label: "Viewport",
                  value: `${_ctx.t.viewportW} x ${_ctx.t.viewportH}`,
                  tone: "cyan",
                  note: "Current window"
                }, null, 8, ["value"]))
        ])
      ], 512)
    ]),
    _hoisted_29
  ], 64))
}